module.exports = __webpack_public_path__ + "static/hero_one-a071fbcd4237022551f7fb21b2c1ab9b.jpg";